import $ from 'jquery';

function getCookie(key){
  var cookies = document.cookie.split('; ');
  for (var i = 0; i < cookies.length; i++){
    var c = cookies[i].split('=');
    if(c[0] == key){
      return c[1];
    }
  }
  return false;
}

if(location.href.match(/^https:\/\/[^\.]+\.aperza/)){
  let base_domain = '.aperza.jp'
  let tokenKey = 'gtoken'
}else if(document.domain.match(/www.aperza.jp/)){
  let base_domain = '.aperza.jp'
  let tokenKey = 'gtoken'
}else if(document.domain.match(/stg.aperza.jp/)){
  let base_domain = '.stg.aperza.jp'
  let tokenKey = 'stggtoken'
}else if(document.domain.match(/test.aperza.jp/)){
  let base_domain = '.test.aperza.jp'
  let tokenKey = 'testgtoken'
}else{
  let base_domain = '.test.aperza.jp'
  let tokenKey = 'testgtoken'
}

export default {
  batchClip: ()=>{
    
    let page_url = location.href
    Object.keys(localStorage).map( function(key){
      if(localStorage[key] == 'clip'){
        page_url = localStorage[key]
        let data = JSON.parse(key)
        let url = `https://api${base_domain}/v2/clip?token=${getCookie(tokenKey)}`
        $.ajax({
            type: 'POST',
            url: url,
            dataType: 'json',
            data: JSON.stringify(data),
            success: function(json) {
              localStorage[key] = 'false'
            }
        });
      }
    } )
  }
}



// WEBPACK FOOTER //
// ./src/lib/util.js